import React from 'react';

import './CollegeDistributeFundMinMax.scss';

import { COLLEGE_DISTRIBUTE_FUND_MIN_MAX_MODAL } from '../../../redux/modules/modals/modals.module';
import { ProductTypes } from 'src/settings/settings';
import Button from '../../Shared/Button/Button';

const CollegeDistributeFundMinMax = ({ closeModal, productType }) => {
  return (
    <div className="college-distribute-fund-min-max-container">
      <h3>Your Daily Minimums & Maximums</h3>
      <p>
        <span className="college-distribute-fund-min-max-emphasize">
          The minimum value
        </span>{' '}
        that can be distributed from a portfolio by ACH or check is $1.00 or
        $1.00 worth of units, and requests by wire transfer are $100 or $100
        worth of units.
      </p>
      <p>
        <span className="college-distribute-fund-min-max-emphasize">
          Daily maximums
        </span>{' '}
        are determined by two factors:
      </p>
      <ol>
        <li>
          <span className="college-distribute-fund-min-max-emphasize">
            Distribution Maximum -{' '}
          </span>
          The maximum amount that may be distributed from a 529 account is{' '}
          {productType === ProductTypes.MARYLAND529
            ? '$49,999.99'
            : '$99,999.99'}{' '}
          per day, or the equivalent value in units.
          <br />
        </li>
        <li>
          <span className="college-distribute-fund-min-max-emphasize">
            Portfolio Maximum Threshold -{' '}
          </span>{' '}
          To account for market fluctuations, distribution maximums are imposed
          for dollar amounts and determined by individual portfolios. In
          volatile market conditions, the permitted maximum dollar amount may
          allow you to enter a distribution amount that is  more than that
          portfolio's day-end balance. If your distribution value is higher than
          your day-end balance, your transaction will fail and not be executed.
          Avoid this scenario by entering a distribution value in{' '}
          <span className="emphasize">percentage or number of units.</span>
        </li>
      </ol>

      <div className="college-distribute-fund-min-max-button-container">
        <Button
          id={`fund-min-max-confirm`}
          buttonType="primary"
          type="button"
          onClick={() => closeModal(COLLEGE_DISTRIBUTE_FUND_MIN_MAX_MODAL)}
        >
          OK
        </Button>
      </div>
    </div>
  );
};

export default CollegeDistributeFundMinMax;
